import React from 'react';
import { bool, object, string } from 'prop-types';
import classNames from 'classnames';
import { useAnalytics } from '@johnlewispartnership/wtr-website-analytics';
import {
  CalendarBooked as CalendarBookedIcon,
  Calendar as CalendarIcon,
} from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton';
import Spinner from '@johnlewispartnership/wtr-ingredients/dist/Spinner';
import { urls } from 'constants/urls';
import styles from './SlotButton.module.scss';
import {
  formatSlotButtonScreenReaderLabel,
  formatSlotButtonText,
} from './utils/format-slot-button';

export const SlotButton = ({ isSlotBooked, slotDetails, slotLoading, testId, isMobile }) => {
  const { trackEvent } = useAnalytics();

  const handleLinkClick = () => {
    trackEvent({
      event: 'click_book_slot',
    });
  };

  const startIcon =
    isSlotBooked && slotDetails.startDateTime ? <CalendarBookedIcon /> : <CalendarIcon />;
  const spinnerTheme = isMobile ? 'dark' : 'light';
  const slotButtonLabelId = `slot-button-label-${testId}`;

  const slotButtonLabel = formatSlotButtonScreenReaderLabel({
    isSlotBooked,
    slotEndDateTime: slotDetails?.endDateTime,
    slotStartDateTime: slotDetails?.startDateTime,
    slotType: slotDetails?.slotType,
  });

  const slotButtonText = formatSlotButtonText({
    isSlotBooked,
    shortTime: isMobile,
    slotEndDateTime: slotDetails?.endDateTime,
    slotStartDateTime: slotDetails?.startDateTime,
  });

  return (
    <div className={styles.wrapper} data-testid={`slot-button-${testId}`}>
      <div className={classNames({ [styles.textOnly]: isMobile })}>
        {isSlotBooked && (
          <span className="sr-only" id={slotButtonLabelId}>
            {slotButtonLabel}
          </span>
        )}
        <LinkAsButton
          aria-describedby={isSlotBooked ? slotButtonLabelId : null}
          aria-label={isSlotBooked ? 'Change slot' : null}
          href={urls.serviceSelection}
          data-testid={`book-slot-button-${testId}`}
          startIcon={!isMobile ? startIcon : undefined}
          onClick={handleLinkClick}
          theme={!isMobile ? 'primary' : 'secondary'}
          type="button"
          width="full"
        >
          {slotLoading ? <Spinner isActive size="small" theme={spinnerTheme} /> : slotButtonText}
        </LinkAsButton>
      </div>
    </div>
  );
};

SlotButton.propTypes = {
  isSlotBooked: bool,
  slotDetails: object,
  slotLoading: bool,
  testId: string,
  isMobile: bool,
};

SlotButton.defaultProps = {
  isSlotBooked: false,
  slotDetails: {},
  slotLoading: false,
  testId: 'desktop',
  isMobile: false,
};
